import {Navigate, Outlet} from 'react-router-dom'
import {LOCAL_STORAGE, PATH} from '@utils/Const'

export function EmptyLayout() {
  const isLoggedIn = () => {
    const retrievedToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
    return !!retrievedToken
  }
  if (isLoggedIn()) {
    return <Navigate to={PATH.HOME} />
  }
  return <Outlet />
}
